// https://api.pping.kr

import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import axios from 'axios'
import {
    MEDIUM_GUIDE_REQUEST, MEDIUM_GUIDE_SUCCESS, MEDIUM_GUIDE_FAILURE,
    MEDIUM_REVIEW_REQUEST, MEDIUM_REVIEW_SUCCESS, MEDIUM_REVIEW_FAILURE,
} from '../reducers/medium'

function mediumDataAPI(cateId) {
    const url = `/front/v1/medium/view/${cateId}`
    return axios.post(url)
}

function* mediumGuide(action) {
    try {
        const result = yield call(mediumDataAPI, action.data)
        yield put({
            type: MEDIUM_GUIDE_SUCCESS,
            data: result.data.data
        })
    } catch (e) {
        console.error(e)
        yield put({
            type: MEDIUM_GUIDE_FAILURE,
        })
    }
}

function mediumReviewAPI({cateId, idx_threads}) {
    const url = `/front/v1/medium/newsReviewView/${cateId}?idx_threads=${idx_threads}`
    return axios.post(url)
}

function* mediumReview(action) {
    try {
        const result = yield call(mediumReviewAPI, action.data)
        yield put({
            type: MEDIUM_REVIEW_SUCCESS,
            data: result.data.data
        })
    } catch (e) {
        console.error(e)
        yield put({
            type: MEDIUM_REVIEW_FAILURE,
        })
    }
}

// 미디엄 가이드
function* watchMediumGuide() {
    yield takeLatest(MEDIUM_GUIDE_REQUEST, mediumGuide)
}

// 미디엄뉴스 리뷰
function* watchMediumReview() {
    yield takeLatest(MEDIUM_REVIEW_REQUEST, mediumReview)
}

export default function* mediumSaga() {
    yield all([fork(watchMediumGuide)])
    yield all([fork(watchMediumReview)])
}



// WEBPACK FOOTER //
// ./src/estimate_list/sagas/medium.js